import React, { FC } from 'react'
import {
  BorderGrayRectBadge,
  BorderRectBadge,
  NolCareBadge,
  PendingReservationBadgeLine,
} from './Badge.styles'
import { ConfigBadgeType } from '~/api/utils/leisure'

interface ConfigBadgeProps {
  badgeType: string
}

const ConfigBadge: FC<ConfigBadgeProps> = ({ badgeType }) => {
  return (
    <>
      {badgeType === ConfigBadgeType.PENDING_RESERVATION && (
        <PendingReservationBadgeLine>예약확정대기</PendingReservationBadgeLine>
      )}
      {badgeType === ConfigBadgeType.CANCEL_PENALTY && <NolCareBadge>NOL케어</NolCareBadge>}
      {badgeType === ConfigBadgeType.MILLION_COUPON && (
        <BorderRectBadge>숙박페스타</BorderRectBadge>
      )}
      {badgeType === ConfigBadgeType.SP_MILLION_COUPON && (
        <BorderRectBadge>숙박페스타 특별편</BorderRectBadge>
      )}
      {badgeType === ConfigBadgeType.LEISURE_COUPON && <BorderRectBadge>놀이대전</BorderRectBadge>}
      {badgeType === ConfigBadgeType.MILLION_COUPON_MOTEL && (
        <BorderRectBadge>모텔대전</BorderRectBadge>
      )}
      {badgeType === ConfigBadgeType.Y_FLUX && <BorderGrayRectBadge>QR체크인</BorderGrayRectBadge>}
      {badgeType === ConfigBadgeType.ONE_OFF_PROMOTION && (
        <BorderRectBadge>이번주특가</BorderRectBadge>
      )}
      {badgeType === ConfigBadgeType.PAYBACK && <BorderRectBadge>1%적립</BorderRectBadge>}
      {badgeType === ConfigBadgeType.LEISURE_PLAY_BATTLE && (
        <BorderRectBadge>레포츠대전</BorderRectBadge>
      )}
    </>
  )
}

export default ConfigBadge
